var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentationNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2738 23.8836V38.5736H24.5838V23.8836H39.2738ZM42.4738 16.6836H21.3838C19.1738 16.6836 17.3838 18.4756 17.3838 20.6836V41.7736C17.3838 43.9836 19.1758 45.7736 21.3838 45.7736H42.4738C44.6838 45.7736 46.4738 43.9816 46.4738 41.7736V20.6836C46.4738 18.4736 44.6818 16.6836 42.4738 16.6836Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4181 23.8836V38.5736H61.7261V23.8836H76.4181ZM79.6161 16.6836H58.5281C56.3181 16.6836 54.5281 18.4756 54.5281 20.6836V41.7736C54.5281 43.9836 56.3201 45.7736 58.5281 45.7736H79.6181C81.8281 45.7736 83.6181 43.9816 83.6181 41.7736V20.6836C83.6181 18.4736 81.8261 16.6836 79.6161 16.6836Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8335 58.1541L79.8464 54.167L69.2501 64.7633L58.6537 54.167L54.6666 58.1541L65.263 68.7504L54.6666 79.3468L58.6537 83.3338L69.2501 72.7375L79.8464 83.3338L83.8335 79.3468L73.2371 68.7504L83.8335 58.1541Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1439 61.2264V75.9164H24.4519V61.2264H39.1439ZM42.3419 54.0264H21.2539C19.0439 54.0264 17.2539 55.8184 17.2539 58.0264V79.1164C17.2539 81.3264 19.0459 83.1164 21.2539 83.1164H42.3439C44.5539 83.1164 46.3439 81.3244 46.3439 79.1164V58.0264C46.3439 55.8184 44.5519 54.0264 42.3419 54.0264Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentationNotFound);
export default __webpack_public_path__ + "static/media/documentationNotFound.b08250946d2b892330a3387a4a6df56c.svg";
export { ForwardRef as ReactComponent };